var _style, _g, _g2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascriptSolutions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Progressive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-7 9 284 284",
    style: {
      enableBackground: "new -7 9 284 284"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2458A6;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#2458A6;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#F2644B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.1,212.5H26.6c-3.5,0-6.3-2.8-6.3-6.3v-142c0-3.5,2.8-6.3,6.3-6.3h217.5c3.5,0,6.3,2.8,6.3,6.3v142 C250.3,209.7,247.5,212.5,244.1,212.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "172.5,252.8 101.5,252.8 111.7,212.2 162.4,212.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 71.1,
    y1: 252.8,
    x2: 203,
    y2: 252.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,59.4c0.9,1.8,1.7,3.7,2.4,5.7c0.6,1.9,2.5,3.2,4.5,3.2h4.8c2.7,0,4.8,2.2,4.8,4.8v9.7 c0,2.7-2.2,4.8-4.8,4.8h-4.8c-2,0-3.9,1.2-4.5,3.2s-1.4,3.9-2.4,5.7c-0.9,1.8-0.5,4,1,5.5l3.4,3.4c1.9,1.9,1.9,5,0,6.8L75,119 c-1.9,1.9-5,1.9-6.8,0l-3.4-3.4c-1.4-1.4-3.7-1.9-5.5-1s-3.7,1.7-5.7,2.4c-1.9,0.6-3.2,2.5-3.2,4.5v4.8c0,2.7-2.2,4.8-4.8,4.8h-9.7 c-2.7,0-4.8-2.2-4.8-4.8v-4.8c0-2-1.2-3.9-3.2-4.5s-3.9-1.4-5.7-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.3,58.7c3.8,3.5,6.1,8.6,6.1,14.1c0,10.7-8.7,19.4-19.4,19.4c-5.9,0-11.2-2.6-14.7-6.8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st2",
    d: "M100.3,160.4l9.8-6c1.8,3.4,3.6,6.2,7.6,6.2s6.4-1.6,6.4-7.6v-40.8h12V153 c0,12.4-7.2,18-17.8,18C108.5,171.4,103.1,166.4,100.3,160.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st2",
    d: "M142.5,159l9.8-5.6c2.6,4.2,6,7.2,11.8,7.2c5,0,8.2-2.4,8.2-6c0-4.2-3.2-5.6-8.8-8l-3-1.2 c-8.6-3.6-14.4-8.2-14.4-18c0-9,6.8-15.8,17.6-15.8c7.6,0,13,2.6,17,9.6l-9.4,6c-2-3.6-4.2-5.2-7.6-5.2c-3.6,0-5.8,2.2-5.8,5.2 c0,3.6,2.2,5,7.4,7.2l3,1.2c10.2,4.4,16,8.8,16,18.8c0,10.8-8.4,16.6-19.8,16.6C153.3,171.4,146.1,166,142.5,159"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptSolutions);
export default __webpack_public_path__ + "static/media/javascript-solutions.553c8cfcc48a94cd96468848e9ece154.svg";
export { ForwardRef as ReactComponent };